<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle">GALVESTON AND THE 1900 STORM<a id="page_xvi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292753952_09_htit1.vue?4b491170